export const formatTimeline = (seconds) => {
    const date = new Date(seconds * 1000);
    const hh = date.getUTCHours();
    const mm = date.getUTCMinutes();
    const ss = date.getUTCSeconds();
    if (hh) {
        return `${hh}:${padTime(mm)}:${padTime(ss)}`;
    }
    return `${mm}:${padTime(ss)}`;
};
export const padTime = (string) => {
    return ("0" + string).slice(-2);
};
//# sourceMappingURL=formatTime.js.map